/* LOOM homepage reviewcarousel. Eigen namespace, geen gedeelde selectors of globals. */
(function () {
  function init() {
    var root = document.getElementById('lmr-reviews');
    if (!root || root.dataset.lmrReady === '1') { return; }
    var track = root.querySelector('[data-lmr-track]');
    var prev = root.querySelector('[data-lmr-prev]');
    var next = root.querySelector('[data-lmr-next]');
    var dots = root.querySelector('[data-lmr-dots]');
    if (!track || !prev || !next || !dots) { return; }
    root.dataset.lmrReady = '1';

    var pages = track.querySelectorAll('.lmr-page');
    var dotEls = dots.querySelectorAll('.lmr-dot');
    if (!pages.length) { return; }
    var i = 0;

    function update() {
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      for (var k = 0; k < dotEls.length; k++) {
        dotEls[k].setAttribute('aria-current', k === i ? 'true' : 'false');
      }
    }
    function go(d) { i = (i + d + pages.length) % pages.length; update(); }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) { return; }
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) { go(dx < 0 ? 1 : -1); }
      x0 = null;
    }, { passive: true });

    update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
